import { __assign } from "tslib";
import React, { useState } from "react";
import { Image, Text, View, Platform } from "react-native";
import { PnmacHeadline, PnmacText, PnmacUIButton, PnmacHtmlToNative } from "pnmac-universal-components";
import moments from "moment";
import { useDispatch, useSelector } from "react-redux";
import { loanCompletedOne, windowObject } from "../../utils";
import Payoff from "./Payoff";
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../../redux/events/events.js";
import { bindActionCreators } from "redux";
import * as Actions from "../../redux/actions/actions";
import GetPayoffRequestSubmitted from "./GetPayoffRequestSubmitted";
import GetPayoffNotAvailable from "./GetPayoffNotAvailable";
import DatePicker from "./DatePicker";
import { textStyle } from '../../v2/theme';
import { trackEvent } from "../../Tealium";
var currentDate = moments(new Date()).format("MM/DD/YYYY");
function GetPayoffStatement(_a) {
  var _b;
  var translations = _a.translations,
    payOffReason = _a.payOffReason,
    tealiumReason = _a.tealiumReason;
  var state = useSelector(function (state) {
    return state;
  });
  var _c = React.useState(new Date()),
    expectedPayOffDate = _c[0],
    setExpectedPayOffDate = _c[1];
  var _d = React.useState(""),
    errorMessage = _d[0],
    setErrorMessage = _d[1];
  var _e = React.useState(""),
    content = _e[0],
    setContent = _e[1];
  var _f = React.useState(false),
    disabled = _f[0],
    setDisabled = _f[1];
  var _g = React.useState(false),
    disabledSecond = _g[0],
    setDisabledSecond = _g[1];
  var _h = React.useState(false),
    loading = _h[0],
    setLoading = _h[1];
  var _j = useState(false),
    submited = _j[0],
    setSubmited = _j[1];
  var _k = useState(true),
    paidoffStatus = _k[0],
    setPaidoffStatus = _k[1];
  var _l = React.useState(false),
    open = _l[0],
    setOpen = _l[1];
  var _m = React.useState(false),
    disabledSubmit = _m[0],
    setDisabledSubmit = _m[1];
  var dispatch = useDispatch();
  var trackerDispatcher = bindActionCreators(Actions, dispatch).trackerDispatcher;
  var status = ((_b = state === null || state === void 0 ? void 0 : state.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status) || {};
  var token = state.token;
  var selectedLoanNumber = state.selectedLoanNumber;
  var submitPayoff = function () {
    setLoading(true);
    fetch("".concat(state === null || state === void 0 ? void 0 : state.pennyHomeUrl, "api/payment/pay_off_demand"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer ".concat(token)
      },
      body: JSON.stringify(payOffDetails)
    }).then(function (res) {
      if (res.ok) {
        setLoading(false);
        return res.json();
      }
    }).then(function (s) {
      var message = '';
      if (s.response == "submited") {
        setSubmited(true);
        if (!state.mobile && payOffReason) {
          windowObject.dataLayer = windowObject.dataLayer || [];
          dataLayer.push({
            event: 'payoff_submitted',
            payoff_reason: payOffReason
          });
        }
        trackEvent('payoff_requested', {
          payoff_reason: tealiumReason,
          start_time: new Date()
        });
      } else if (s.response == "exists") {
        setErrorMessage("A payoff for this loan has already been submitted for the same date.");
        message = "A payoff for this loan has already been submitted for the same date.";
      } else if (s.response == "event error") {
        setErrorMessage("There was a problem submitting your payoff request. Please try again.");
        message = 'There was a problem submitting your payoff request. Please try again.';
      } else if (s.response == "todaySubmit") {
        setErrorMessage("Our records indicate you have already submitted a request today. Please try again tomorrow.");
        message = 'Our records indicate you have already submitted a request today. Please try again tomorrow.';
      }
    }).catch(function (err) {
      setLoading(false);
    });
    trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Get My Payoff Statement Button Clicked", 0);
  };
  React.useEffect(function () {
    var paidoff = loanCompletedOne(status).isCompletedOne;
    if (paidoff) {
      setPaidoffStatus(false);
    } else {
      fetch("".concat(state === null || state === void 0 ? void 0 : state.pennyHomeUrl, "api/main/get_payoff_info?loanId=").concat(state === null || state === void 0 ? void 0 : state.selectedLoanNumber), {
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(state === null || state === void 0 ? void 0 : state.token)
        }
      }).then(function (d) {
        return d.json();
      }).then(function (s) {
        if (s.onlyShowAvailableDates && s.asOfGoodThroughDate1 == s.asOfGoodThroughDate2) {
          setContent("FHA loans closed prior to 1/21/2015 must pay interest through the end of the month.");
          setExpectedPayOffDate(moments(s.asOfGoodThroughDate1, "MM/DD/YYYY").isValid() ? moments(s.asOfGoodThroughDate1, "MM/DD/YYYY").format("MM/DD/YYYY") : moments(s.asOfGoodThroughDate1).format("MM/DD/YYYY"));
          setDisabled(true);
        } else if (s.onlyShowAvailableDates && s.asOfGoodThroughDate1 != s.asOfGoodThroughDate2) {
          setExpectedPayOffDate(moments(s.asOfGoodThroughDate1, "MM/DD/YYYY").isValid() ? moments(s.asOfGoodThroughDate1, "MM/DD/YYYY").format("MM/DD/YYYY") : moments(s.asOfGoodThroughDate1).format("MM/DD/YYYY"));
          setDisabledSecond(true);
          setContent("FHA loans closed prior to 1/21/2015 must pay interest through the end of this month or the next.");
        } else {
          setContent("Please choose a payoff date within the next 30 days.");
        }
      });
    }
  }, [status]);
  var payOffDetails = {
    requestDetailsId: 0,
    loanId: selectedLoanNumber,
    payOffReason: "",
    expectedPayoffDate: moments(expectedPayOffDate || currentDate, "MM/DD/YYYY").isValid() ? moments(expectedPayOffDate || currentDate, "MM/DD/YYYY").format("MM/DD/YYYY") : moments(expectedPayOffDate || currentDate).format("MM/DD/YYYY")
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: {
      backgroundColor: "#fff",
      margin: 10,
      padding: 15,
      shadowColor: "rgba(0,0,0, .08)",
      shadowOffset: {
        height: 4,
        width: 2
      },
      shadowOpacity: 1,
      shadowRadius: 12,
      elevation: 4,
      borderRadius: 10
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      borderBottomWidth: 1,
      borderBottomColor: "#efefef"
    }
  }, /*#__PURE__*/React.createElement(PnmacHeadline, {
    style: {
      paddingBottom: 20
    }
  }, "My Mortgage")), submited ? /*#__PURE__*/React.createElement(GetPayoffRequestSubmitted, {
    translations: translations
  }) : paidoffStatus ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    style: __assign(__assign({}, textStyle.defaultTextTitle), {
      color: "#003087",
      fontWeight: "bold",
      marginTop: 20,
      marginBottom: 10
    })
  }, translations.ExpectedPayoffDate), /*#__PURE__*/React.createElement(DatePicker, {
    disabled: disabled,
    expectedPayOffDate: expectedPayOffDate,
    setExpectedPayOffDate: function (date) {
      setExpectedPayOffDate(date);
      if (disabledSecond) {
        setErrorMessage('');
        setContent('FHA loans closed prior to 1/21/2015 must pay interest through the end of the month.');
      }
    },
    setOpen: setOpen,
    setDisabledSubmit: setDisabledSubmit,
    disabledSecond: disabledSecond,
    currentDate: currentDate,
    open: open,
    setErrorMessage: function () {
      setErrorMessage('FHA loans closed prior to 1/21/2015 must pay interest through the end of the month.');
      setContent('');
    }
  }), !!errorMessage && /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      color: "red",
      marginTop: 10
    }
  }, errorMessage), /*#__PURE__*/React.createElement(PnmacText, {
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      marginVertical: 10,
      color: "#000"
    })
  }, content), !errorMessage && /*#__PURE__*/React.createElement(PnmacUIButton, {
    mode: 'contained',
    onPress: function () {
      return submitPayoff();
    },
    loading: loading,
    disabled: state.pennyWise
  }, translations.GetMyPayoffStatement)) : /*#__PURE__*/React.createElement(GetPayoffNotAvailable, {
    translations: translations
  })), /*#__PURE__*/React.createElement(View, {
    style: {
      margin: 10
    }
  }, !submited && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacHeadline, null, "Next Steps"), [{
    image: require("../../assets/Step01.png"),
    content: translations.GetPayoffStepOne
  }, {
    image: require("../../assets/Step02.png"),
    content: translations.GetPayoffStepTwo
  }, {
    image: require("../../assets/Step03.png"),
    content: translations.GetPayoffStepThree
  }].map(function (item, index) {
    return /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: "row",
        marginTop: 10
      },
      key: String(index)
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        width: 35,
        height: 35,
        marginRight: 10
      },
      source: item.image
    }), /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, textStyle.defaultTextDescription), {
        flex: 1
      })
    }, item.content));
  })), /*#__PURE__*/React.createElement(PnmacHeadline, {
    style: {
      marginTop: 20
    }
  }, "Important Payoff Information"), [{
    image: require("../../assets/getpayoff-money.png"),
    title: "Your Pennymac AutoPay",
    content: translations.GetPayoffYourAutoPay
  }, {
    image: require("../../assets/getpayoff-bank.png"),
    title: "Your Escrow Refund",
    content: translations.GetPayoffEscrowRefund
  }, {
    image: require("../../assets/getpayoff-paper.png"),
    title: "Release of Your Lien",
    content: translations.GetPayoffReleaseLien
  }, {
    image: require("../../assets/getpayoff-dollar.png"),
    title: "Year-End Statements",
    content: translations.GetPayoffYearEnd
  }].map(function (item, index) {
    return /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: "row",
        marginTop: 15
      },
      key: String(index)
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        width: 35,
        height: 35,
        marginRight: 10
      },
      source: item.image
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        flex: 1
      })
    }, item.title), /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, textStyle.defaultTextDescription), {
        flex: 1
      })
    }, item.content)));
  }), submited && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacHeadline, {
    style: {
      marginTop: 20
    }
  }, "Remember"), [{
    image: require("../../assets/Check-Icon.png"),
    content: translations.GetPayoffRequestSubmitted4
  }, {
    image: require("../../assets/Check-Icon.png"),
    content: translations.GetPayoffRequestSubmitted5
  }, {
    image: require("../../assets/Check-Icon.png"),
    content: translations.GetPayoffRequestSubmitted6
  }].map(function (item, index) {
    return /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: "row",
        marginTop: 15,
        alignItems: "center"
      },
      key: String(index)
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        width: 35,
        height: 35,
        marginRight: 10
      },
      source: item.image
    }), /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, textStyle.defaultTextDescription), {
        flex: 1
      })
    }, item.content));
  }))), /*#__PURE__*/React.createElement(Payoff, {
    translations: translations
  }));
}
export default GetPayoffStatement;